import React from 'react';
import { InstitutionListComponent } from '@moxie/shared';

const Institution: React.FC = () => {
  return <InstitutionListComponent />;
};

export default Institution;
